export default __webpack_public_path__ + "static/media/onei.e6754ab0.png";